/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Missing_TitleInputs */

const en_recipe_missing_title = /** @type {(inputs: Recipe_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipe not found`)
};

const de_recipe_missing_title = /** @type {(inputs: Recipe_Missing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept nicht gefunden`)
};

/**
* | output |
* | --- |
* | "Recipe not found" |
*
* @param {Recipe_Missing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_missing_title = /** @type {((inputs?: Recipe_Missing_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Missing_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_missing_title(inputs)
	return en_recipe_missing_title(inputs)
});